import React from 'react'
import BadgeLib from '@material-ui/core/Badge'
import standardPropTypes, { Style } from '../DefaultPropTypes'

function Badge({
  children, className, badgeContent, color,
}) {
  return (
    <BadgeLib badgeContent={badgeContent} className={className} color={color}>
      { children }
    </BadgeLib>
  )
}

Badge.propTypes = {
  color: Style.isRequired,
  ...standardPropTypes,
}

export default Badge
